import './Team.scss';
import Semaphore from 'semaphore-async-await';
import { sortByStringValue, debounce } from 'data/function';
import { DeskControllerBase } from '../DeskControllerBase';
import { AccountFeatures } from 'modules/account/AccountFeatures';
import { AttendanceFeatures } from '../AttendanceFeatures';
import { AttendanceConstants } from '../AttendanceConstants';
import { TeamConstants } from './TeamConstants';
var AgentsTableCategories;
(function (AgentsTableCategories) {
    AgentsTableCategories["Name"] = "name";
    AgentsTableCategories["Email"] = "email";
    AgentsTableCategories["Teams"] = "teams";
    AgentsTableCategories["Slots"] = "slots";
})(AgentsTableCategories || (AgentsTableCategories = {}));
export class TeamController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'TeamService', '$rootScope', '$translate', 'ConfigurationsService', 'SegmentService', 'AuthenticationService', 'BlipToastService', 'BLIP_DOMAIN', 'QueuesService', 'TenantService', '$state', '$window'];
    constructor(application, DeskConfigurationService, LoadingService, $scope, TeamService, $rootScope, $translate, ConfigurationsService, SegmentService, AuthenticationService, BlipToastService, BLIP_DOMAIN, QueuesService, TenantService, $state, $window) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.$scope = $scope;
        this.TeamService = TeamService;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.ConfigurationsService = ConfigurationsService;
        this.SegmentService = SegmentService;
        this.AuthenticationService = AuthenticationService;
        this.BlipToastService = BlipToastService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.QueuesService = QueuesService;
        this.TenantService = TenantService;
        this.$state = $state;
        this.$window = $window;
        this.attendants = [];
        this.teams = [];
        this.isContractAdmin = false;
        this.tagInputFieldText = '';
        this.tagTextLengthError = false;
        this.tagSubmitError = false;
        this.tagMaxLength = 30;
        this.take = 999999;
        this.skip = 0;
        this.attendantsTotalCount = 0;
        // Attendence Batch
        this.isOpenAttendanceSection = false;
        this.newAttendants = [];
        this.newTeams = [];
        this.editingQueues = [];
        this.newAgentSlotsError = '';
        this.newTeamsError = '';
        this.newAttendantsError = '';
        this.isNewAttendantsValid = false;
        this.isNewAgentSlotsValid = false;
        this.isNewTeamsValid = false;
        this.attendantsOptionsData = [];
        this.optionsData = [];
        this.filterOptionsData = [];
        this.hasForbiddenTeam = false;
        this.inputQueuesReadyValidation = false;
        this.isFakeAtendanceProfileEnabled = false;
        this.newSalesAgent = false;
        this.newSupportAgent = false;
        this.openFakeProfileModal = false;
        this.searchChange = async (event) => {
            this.searchText = event.detail.value;
            this.SegmentService.createBotTrack('helpdesk-agents-searched', this.application);
            this.cancelAddAttendant();
            if (this.searchText.length >= 3 || this.searchText.length == 0) {
                this.isLoading = true;
                this.query(true);
            }
        };
        this.checkSelectionSlots = (ev) => {
            this.editingSelectionSlots = ev.detail.value;
        };
        this.selectTeam = (event) => {
            const selectedValue = event.detail?.value;
            this.team = selectedValue || '';
        };
        // Attendence Batch
        this.onChangeChipsEmails = (event) => {
            const { detail: { data } } = event;
            this.newAttendants = data.map(Function.prototype.call, String.prototype.trim);
        };
        this.onChangeChipsAttendants = (event) => {
            const { detail: { data } } = event;
            this.newAttendants = data.map(Function.prototype.call, String.prototype.trim);
            this.isValidNewSlots();
            this.isValidNewAttendants();
        };
        this.onChangeChipsTeams = (event) => {
            const { detail: { data } } = event;
            this.newTeams = data.map(Function.prototype.call, String.prototype.trim);
            this.isValidNewTeams();
        };
        this.onChangeInputQueues = (event) => {
            const { detail: { data } } = event;
            this.newTeams = data.map(Function.prototype.call, String.prototype.trim);
        };
        this.onChangeEditQueues = (event) => {
            const { detail: { data } } = event;
            this.editingSelectionTeams = data.map(Function.prototype.call, String.prototype.trim);
            this.selectionTeamsError();
        };
        this.onBlurInputQueues = (event) => {
            this.inputQueuesReadyValidation = true;
            setTimeout(() => {
            }, 500);
        };
        this.onChangeAgentSlots = (event) => {
            const { detail: { value } } = event;
            this.newAgentSlots = value === '' ? undefined : value;
        };
        this.isValidNewAttendants = async () => {
            const form = this.formElements();
            if (!this.isBillablePlanContract) {
                await this.convertAttendantsValueToChip(form.attendants);
            }
            if (!this.newAttendants || this.newAttendants.length <= 0) {
                form.attendants?.setAttribute('danger', 'true');
                this.newAttendantsError = this.$translate.instant('modules.application.detail.attendance.team.form.emptyEmails');
                this.isNewAttendantsValid = false;
                return;
            }
            let inputValid;
            if (!this.isBillablePlanContract) {
                inputValid = await form.attendants.isValid();
            }
            else {
                inputValid = true;
            }
            if (!this.newAttendants || !inputValid) {
                form.attendants?.setAttribute('danger', 'true');
                this.newAttendantsError = this.$translate.instant('modules.application.detail.attendance.team.form.invalidEmails');
                this.isNewAttendantsValid = false;
                return;
            }
            this.newAttendantsError = '';
            this.isNewAttendantsValid = true;
            form.attendants?.removeAttribute('danger');
        };
        this.isValidNewTeams = async () => {
            const form = this.formElements();
            if (!this.newAttendants) {
                form.teams.danger = true;
                this.newTeamsError = this.$translate.instant('modules.application.detail.attendance.team.form.invalidTeams');
                this.isNewTeamsValid = false;
                return;
            }
            form.teams.danger = false;
            this.newTeamsError = '';
            this.isNewTeamsValid = true;
            this.hasForbiddenTeam = false;
        };
        this.isValidNewSlots = () => {
            const form = this.formElements();
            if (this.ownerAgentSlots && (this.newAgentSlots === undefined || this.newAgentSlots === null)) {
                form.slots.setAttribute('danger', 'true');
                this.newAgentSlotsError = this.$translate.instant('modules.application.detail.attendance.team.form.emptyAgentSlots');
                this.isNewAgentSlotsValid = false;
                return;
            }
            if (this.ownerAgentSlots && this.newAgentSlots < 0) {
                this.newAgentSlotsError = this.$translate.instant('modules.application.detail.attendance.team.form.invalidAgentSlots');
                form.slots.setAttribute('danger', 'true');
                this.isNewAgentSlotsValid = false;
                return;
            }
            if (this.ownerAgentSlots) {
                form.slots.removeAttribute('danger');
            }
            this.isNewAgentSlotsValid = true;
        };
        this.selectSales = () => {
            this.selectProfile(true);
        };
        this.selectSupport = () => {
            this.selectProfile(false);
        };
        this.selectProfile = (isSales) => {
            this.newSalesAgent = isSales;
            this.newSupportAgent = !this.newSalesAgent;
        };
        this.toggleOpenFakeProfileModal = () => {
            this.toggleFakeModal(AttendanceConstants.TRACKING_OPEN_MODAL_FAKE_PROFILE);
        };
        this.toggleCloseFakeProfileModal = () => {
            this.toggleFakeModal(AttendanceConstants.TRACKING_CLOSE_MODAL_FAKE_PROFILE);
        };
        this.toggleFakeModal = (trackingName) => {
            this.openFakeProfileModal = !this.openFakeProfileModal;
            this.trackEvent(trackingName);
        };
        // Used to limit simultaneous requests for agents batch edition
        this.lock = new Semaphore(10);
        this.debouncedSearch = debounce(this.searchChange, 500);
    }
    async $onInit() {
        this.searchText = '';
        this.isLoading = true;
        this.filteredTeams = [];
        this.isDropdownOpen = false;
        this.editingSelectionTeams = [];
        this.editingSelectionSlots = undefined;
        this.editingAttendantIdentity = undefined;
        this.hoverAttendantIdentity = undefined;
        this.isAnyAttendantSelected = false;
        this.numberOfAttendantsSelected = 0;
        this.team = '';
        this.isBillablePlanContract = await this.TenantService.checkIfBillableContract();
        this.queues = [];
        await this.getQueues();
        const isAttendantMfeEnabled = await AttendanceFeatures.isAttendantMfeEnabled();
        if (isAttendantMfeEnabled) {
            this.$state.go('auth.application.detail.attendance.desk.team');
            return;
        }
        this.getSelectionTranslateValues();
        this.categoriesEnum = { ...AgentsTableCategories };
        const deregisterDropdownButtonClick = this.$rootScope.$on('DropdownItemButtonClicked', () => {
            if (this.editingAttendantIdentity && this.hoverAttendantIdentity === this.editingAttendantIdentity) {
                const attendant = this.attendants.find((attendant) => {
                    return (this.editingAttendantIdentity === attendant.identity);
                });
                this.clearEditForm(attendant);
                this.closeDropdown();
            }
            else {
                this.editingAttendantIdentity = this.hoverAttendantIdentity || undefined;
                this.isDropdownOpen = (this.editingAttendantIdentity) ? true : !this.isDropdownOpen;
                if (!this.isDropdownOpen) {
                    this.clearEditForm();
                }
            }
        });
        const deregisterDropdownItemClosed = this.$rootScope.$on('DropdownItemClosed', () => {
            this.clearEditForm();
            this.closeDropdown(false);
        });
        const watchScopeCleanup = this.$scope.$watch(() => {
            return this.tagInputFieldText;
        }, (text) => {
            this.tagSubmitError = false;
            this.tagTextLengthError = (text && text.length > this.tagMaxLength);
        });
        this.$scope.$on('$destroy', () => {
            deregisterDropdownButtonClick();
            deregisterDropdownItemClosed();
            watchScopeCleanup();
        });
        if (this.isAgentPaginatorEnabled) {
            this.take = 100;
        }
        this.loggedUser = this.AuthenticationService.getAccount();
        await this.getTeams();
        await this.query(false);
        if (this.isBillablePlanContract) {
            await this.getAttendantsInContractOptions();
            try {
                this.isContractAdmin = await this.TenantService.isContractAdmin(this.loggedUser.identity);
            }
            catch (err) {
                this.isContractAdmin = false;
            }
        }
        this.SegmentService.createBotTrack('helpdesk-agents-opened', this.application);
    }
    async checkFeatures() {
        await super.checkFeatures();
        this.isBlipAccountEnabled = await AccountFeatures.isBlipAccountEnabled();
        this.isAgentPaginatorEnabled = await AttendanceFeatures.isAgentPaginatorEnabled();
        this.isAttendancePermissionEnabled = await AttendanceFeatures.isAttendancePermissionEnabled();
        this.isDeleteAttendantDelegationDisabled = await AttendanceFeatures.isDeleteAttendantDelegationDisabled();
        this.isFakeAtendanceProfileEnabled = await AttendanceFeatures.isFakeAtendanceProfileEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
    }
    getSelectionTranslateValues() {
        this.selectionTranslateValues = {
            number: this.numberOfAttendantsSelected,
            plural: (this.isAnyAttendantSelected && this.numberOfAttendantsSelected !== 1) ? 's' : '',
        };
    }
    async getQueues() {
        try {
            const take = 100;
            let skip = 0;
            const { items, total } = await this.QueuesService.getQueues(skip, take);
            let allItems = items;
            while (allItems.length < total) {
                skip += take;
                const { items } = await this.QueuesService.getQueues(skip, take);
                allItems = allItems.concat(items);
            }
            this.queues = allItems ? allItems.map((item) => {
                item.id = item.id;
                item.ownerIdentity = item.ownerIdentity;
                item.name = item.name;
                item.isActive = item.isActive;
                item.opened = item.opened;
                return item;
            }) : [];
        }
        catch (e) {
            this.queues = [];
        }
    }
    async getTeams() {
        try {
            const { items } = await this.TeamService.getTeams(this.application);
            this.teams = items
                .map((item) => ({
                ...item,
                value: item.name,
                label: item.name,
            }))
                .sort(sortByStringValue);
            this.optionsData = this.teams.map((team) => ({ value: team.name, label: team.name })).sort(sortByStringValue);
            this.optionsData = this.queues.map((team) => ({ value: team.name, label: team.name })).sort(sortByStringValue);
            this.filterOptionsData = this.optionsData;
            this.formElements().teams.options = this.optionsData;
        }
        catch (e) {
            this.optionsData = this.queues.map((team) => ({ value: team.name, label: team.name })).sort(sortByStringValue);
        }
    }
    async getAttendantsInContractOptions() {
        const tenantId = await this.TenantService.getTenantPrefixFromUrl();
        const attendantsOnBot = this.attendants.slice();
        let attendantsInContract = [];
        const attendants = await this.TeamService.getAttendantsInContract(tenantId);
        try {
            attendantsInContract = attendants.items
                .map((i) => ({
                identity: i.userIdentity,
                email: decodeURIComponent(i.userIdentity.split('@')[0]),
                fullName: i.fullName || decodeURIComponent(i.userIdentity.split('@')[0]),
                isEnabled: i.isEnabled ?? true,
            }));
        }
        catch (error) {
            const err = JSON.parse(error);
            if (err.reason.code == 67 && err.reason.description == 'The requested resource was not found') {
                attendantsInContract = [];
            }
        }
        const disabledAttendantStatus = await this.$translate.instant('modules.application.detail.attendance.team.disabled');
        this.attendantsOptionsData = this.generateAttendantsOptionsData(attendantsOnBot, attendantsInContract, disabledAttendantStatus);
    }
    generateAttendantsOptionsData(attendantsOnBot, attendantsInContract, disabledAttendantStatus) {
        return attendantsInContract
            .filter((aIC) => !attendantsOnBot.find((aOB) => aIC.email === aOB.email))
            .map((a) => ({ value: a.email, label: a.email, status: (this.isBillablePlanContract && !a.isEnabled) ? disabledAttendantStatus : '' }));
    }
    get noResultsFound() {
        return (!this.isLoading &&
            this.attendants?.length == 0 &&
            this.searchText?.length > 0);
    }
    async clearSearch() {
        this.searchText = '';
    }
    reset() {
        this.skip = 0;
        this.attendants = [];
    }
    async query(reset = false, filteredTeams) {
        this.isLoading = true;
        if (filteredTeams) {
            this.filteredTeams = filteredTeams;
        }
        if (reset) {
            this.reset();
        }
        try {
            const agentSettings = await this.ConfigurationsService.get('postmaster@desk.msging.net', undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            if (agentSettings.AgentSlotsEnabled !== 'False' && agentSettings.AgentSlots !== undefined) {
                this.ownerAgentSlots = Number(agentSettings.AgentSlots);
            }
            const filter = this.getFilters();
            const { items, total } = await this.TeamService.getAttendants(filter, this.skip, this.take);
            this.attendantsTotalCount = total;
            const attendants = items ? items.map((item) => {
                const agentSlots = (item.agentSlots === undefined || this.ownerAgentSlots === 0) ?
                    this.ownerAgentSlots :
                    item.agentSlots;
                this.setAttendantValues(item, item.teams, agentSlots);
                return item;
            }) : [];
            attendants.forEach((att) => {
                if (!this.attendants.find((att2) => att2.identity == att.identity)) {
                    this.attendants.push(att);
                }
            });
            this.skip = this.attendants.length;
            this.canLoadMore = this.attendants.length !== this.attendantsTotalCount;
            if (!this.isAgentPaginatorEnabled) {
                this.attendants = this.filterAttendantsByText(this.searchText);
            }
        }
        catch (e) {
            if (e.code === 67) {
                this.canLoadMore = false;
            }
            else {
                console.error(e);
                this.attendants = [];
            }
        }
        finally {
            this.isAnyAttendantSelected = false;
            this.numberOfAttendantsSelected = 0;
            this.isLoading = false;
        }
    }
    hasFilteredTeams() {
        return this.filteredTeams?.length > 0;
    }
    filterAttendantsByText(term) {
        if (!term) {
            return this.attendants;
        }
        return this.attendants.filter((a) => (a.email && a.email.indexOf(term) != -1) ||
            (a.fullName && a.fullName.indexOf(term) != -1));
    }
    filterByIdentity(term) {
        return `substringof('${encodeURIComponent(term)}', identity)`;
    }
    filterByTeam(term) {
        return `substringof('${term}',teams)`;
    }
    getFilterByIdentity(hasPrev) {
        if (!this.searchText) {
            return '';
        }
        if (this.searchText && hasPrev) {
            return ` and ${this.filterByIdentity(this.searchText)}`;
        }
        else {
            return this.filterByIdentity(this.searchText);
        }
    }
    getFilterByTeams() {
        let filters = '';
        let hasPrev = false;
        filters += '(';
        this.filteredTeams.forEach((team) => {
            if (hasPrev) {
                filters += ' or ';
            }
            filters += this.filterByTeam(team.text);
            hasPrev = true;
        });
        return filters += ')';
    }
    getFilters() {
        const hasFilteredTeams = this.hasFilteredTeams();
        let filters = '';
        if (hasFilteredTeams) {
            filters += this.getFilterByTeams();
        }
        if (this.isAgentPaginatorEnabled) {
            filters += this.getFilterByIdentity(hasFilteredTeams);
        }
        return filters;
    }
    addTeamFilter(item) {
        if (!item) {
            return;
        }
        this.SegmentService.createBotTrack('helpdesk-agents-filtered', this.application);
        const removedItem = this.filterOptionsData.find((team) => team.value == item);
        this.filterOptionsData = this.filterOptionsData.filter((team) => team.value != item);
        this.filteredTeams = this.filteredTeams.concat({
            text: removedItem.label,
            item: removedItem,
        });
        this.clearTeamFilterDropdown();
        this.query(true, this.filteredTeams);
    }
    removeTeamFilter(items, removedItem) {
        this.teams = this.teams.concat(removedItem.item);
        this.teams = this.teams.sort(sortByStringValue);
        this.filteredTeams = items;
        const filteredTeamsItems = items.map(a => a.item);
        this.filterOptionsData = this.optionsData.filter((team) => !filteredTeamsItems.includes(team));
        this.query(true, this.filteredTeams);
    }
    clearTeamFilterDropdown() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.clearAutocompleteElements(['#team-filter-select']);
    }
    clearAutocompleteElements(elementsId) {
        elementsId.forEach(elementId => {
            const element = document.querySelector(elementId);
            if (element) {
                element.value = undefined;
            }
        });
    }
    addTeamFilterClearInput() {
        this.addTeamFilter(this.team);
        this.clearTeamFilterDropdown();
    }
    resetTerms() {
        this.filteredTeams = this.filteredTeams = [];
        this.clearTeamFilterDropdown();
        this.query(true);
    }
    clearAndUpdate() {
        this.searchText = '';
        this.resetTerms();
    }
    onCheckAttendant(selected) {
        this.updateNumberOfAttendantsSelected();
        this.getSelectionTranslateValues();
    }
    onCheckAll(selected) {
        this.attendants = this.attendants.map((attendant) => ({
            ...attendant,
            checkSelected: selected,
        }));
        this.updateNumberOfAttendantsSelected();
        this.getSelectionTranslateValues();
    }
    updateNumberOfAttendantsSelected() {
        this.numberOfAttendantsSelected = this.attendants.filter((attendant) => {
            return attendant.checkSelected;
        }).length;
        this.isAnyAttendantSelected = (this.numberOfAttendantsSelected > 0);
    }
    getCheckedAttendants() {
        const checked = this.attendants.filter((attendant) => {
            return attendant.checkSelected;
        });
        return checked;
    }
    shouldShowIcons(attendant) {
        return this.isDropdownOpen ?
            this.editingAttendantIdentity === attendant.identity :
            this.hoverAttendantIdentity === attendant.identity;
    }
    closeDropdown(broadcast = false) {
        this.isDropdownOpen = false;
        this.editingAttendantIdentity = undefined;
        this.inputQueues = [];
        if (broadcast) {
            this.broadcastToggleDropdown();
        }
    }
    broadcastToggleDropdown() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
    }
    clearEditAttendantDropdown(attendant = undefined) {
        this.clearEditForm(attendant);
        this.closeDropdown(true);
    }
    clearEditSelectionDropdown() {
        this.clearEditForm();
        this.broadcastToggleDropdown();
        this.closeDropdown(true);
    }
    clearEditForm(attendant = undefined) {
        if (attendant) {
            this.setAttendantValues(attendant, attendant.teams, attendant.agentSlots);
        }
        this.tagInputFieldText = '';
        this.editingSelectionSlots = undefined;
        this.editingSelectionTeams = [];
    }
    async submitEditAttendant(attendant) {
        const teams = attendant.editingTeams.map((t) => t.label);
        if (this.tagInputFieldText) {
            this.tagSubmitError = true;
            return;
        }
        if (this.agentSlotsError(attendant)) {
            return;
        }
        this.LoadingService.startLoading();
        this.SegmentService.createBotTrack('helpdesk-agent-changed', this.application);
        try {
            this.closeDropdown(true);
            await this.saveAttendant({
                ...attendant,
                editForm: undefined,
                teams: teams,
                agentSlots: (attendant.editingAgentSlots == this.ownerAgentSlots) ? undefined : attendant.editingAgentSlots,
            });
            this.setAttendantValues(attendant, teams, attendant.editingAgentSlots);
            const successMsg = await this.$translate('utils.successMsg.38');
            this.BlipToastService.show('success', {
                msg: successMsg,
            });
        }
        catch (e) {
            if (e == AttendanceConstants.CREATE_DIRECT_TRANSFER_TEAM_ERROR) {
                await this.displayDirectTransferError(false);
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async submitEditSelection() {
        if (this.tagInputFieldText) {
            this.tagSubmitError = true;
            return;
        }
        if (this.selectionInputAusenceError()) {
            return;
        }
        if (this.selectionSlotsError()) {
            return;
        }
        this.isLoading = true;
        this.SegmentService.createBotTrack('helpdesk-agent-selection-changed', this.application);
        const selectedAttendants = this.getCheckedAttendants();
        const inputTeams = !this.selectionTeamsError() ? this.editingSelectionTeams : undefined;
        const inputAgentSlots = (this.editingSelectionSlots == this.ownerAgentSlots) ? undefined : this.editingSelectionSlots;
        try {
            const savePromises = selectedAttendants.map(async (attendant) => {
                const teams = inputTeams || attendant.teams;
                const agentSlots = (this.editingSelectionSlots === undefined) ? attendant.agentSlots : inputAgentSlots;
                await this.lock.wait();
                return this.TeamService.set([{
                        ...attendant,
                        teams,
                        agentSlots,
                    }], this.loggedUser.culture).then(() => {
                    this.setAttendantValues(attendant, teams, agentSlots);
                    this.lock.signal();
                }).catch(() => {
                    this.lock.signal();
                });
            });
            this.clearEditSelectionDropdown();
            await Promise.all(savePromises);
            const successMsg = await this.$translate('utils.successMsg.38', this.selectionTranslateValues);
            this.BlipToastService.show('success', {
                msg: successMsg,
            });
        }
        catch (err) {
            const errorMsg1 = await this.$translate('utils.errorMsg.161', this.selectionTranslateValues);
            this.BlipToastService.show('danger', {
                msg: errorMsg1,
            });
        }
        finally {
            try {
                await this.getTeams();
            }
            catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        }
    }
    selectionTeamsError() {
        return (!this.editingSelectionTeams?.length || this.editingSelectionTeams?.length === 0);
    }
    setAttendantValues(attendant, teams = [], agentSlots) {
        attendant.email = attendant.email || decodeURIComponent(attendant.identity.split('@')[0]);
        attendant.fullName = attendant.fullName || attendant.email.split('@')[0];
        attendant.teams = teams;
        attendant.editingTeams = teams.map((t) => ({ value: t, label: t }));
        attendant.agentSlots = agentSlots;
        attendant.editingAgentSlots = agentSlots;
    }
    async saveAttendant(attendant) {
        try {
            await this.TeamService.set([attendant], this.loggedUser.culture);
            await this.getTeams();
        }
        catch (e) {
            if (e.description.includes('Operator must belong to at least one team')) {
                const errorMsg = await this.$translate('utils.errorMsg.125');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
            }
            else if (e == AttendanceConstants.CREATE_DIRECT_TRANSFER_TEAM_ERROR) {
                throw e;
            }
            else {
                const errorMsg = await this.$translate('utils.errorMsg.161');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
            }
        }
    }
    async delete(attendant) {
        this.isLoading = true;
        this.SegmentService.createBotTrack('helpdesk-agent-deleted', this.application);
        try {
            this.closeDropdown(true);
            window.scrollTo(0, -100);
            await this.TeamService.delete(attendant);
            if (!this.isDeleteAttendantDelegationDisabled) {
                await this.TeamService.deleteDelegation(attendant);
            }
            this.attendants = this.attendants.removeItem(attendant);
            this.attendantsTotalCount = this.attendantsTotalCount - 1;
            this.canLoadMore = this.attendants.length !== this.attendantsTotalCount;
            const successMsg = await this.$translate('utils.successMsg.29');
            if (this.isBillablePlanContract) {
                await this.getAttendantsInContractOptions();
            }
            this.BlipToastService.show('success', {
                msg: successMsg,
            });
        }
        catch (e) {
            const errorMsg = await this.$translate('utils.errorMsg.110');
            this.BlipToastService.show('danger', {
                msg: errorMsg,
            });
        }
        finally {
            this.updateNumberOfAttendantsSelected();
            this.isLoading = false;
            await this.query(true);
        }
    }
    async deleteSelection() {
        this.isLoading = true;
        this.SegmentService.createBotTrack('helpdesk-agent-selection-deleted', this.application);
        const selectedAttendants = this.getCheckedAttendants();
        try {
            this.closeDropdown(true);
            let deletePromises;
            deletePromises = selectedAttendants.map((attendant) => {
                return new Promise(async (resolve, reject) => {
                    try {
                        await this.TeamService.delete(attendant);
                        if (!this.isDeleteAttendantDelegationDisabled) {
                            await this.TeamService.deleteDelegation(attendant);
                        }
                        this.attendants = this.attendants.removeItem(attendant);
                        this.attendantsTotalCount = this.attendantsTotalCount - 1;
                        this.canLoadMore = this.attendants.length !== this.attendantsTotalCount;
                        resolve(undefined);
                    }
                    catch (e) {
                        reject(e);
                    }
                });
            });
            await Promise.all(deletePromises);
            if (this.isBillablePlanContract) {
                await this.getAttendantsInContractOptions();
            }
            const successMsg = await this.$translate('utils.successMsg.29', this.selectionTranslateValues);
            this.BlipToastService.show('success', {
                msg: successMsg,
            });
        }
        catch (e) {
            console.error(e);
            const errorMsg = await this.$translate('utils.errorMsg.110', this.selectionTranslateValues);
            this.BlipToastService.show('danger', {
                msg: errorMsg,
            });
        }
        finally {
            this.updateNumberOfAttendantsSelected();
            await this.getTeams();
            await this.query(true);
            this.isLoading = false;
        }
    }
    selectionInputAusenceError() {
        return (this.selectionTeamsError() &&
            (this.editingSelectionSlots === undefined || this.editingSelectionSlots === null));
    }
    selectionSlotsError() {
        return (this.ownerAgentSlots && (this.editingSelectionSlots && this.selectionSlotsNegativeError()));
    }
    selectionSlotsNegativeError() {
        return (this.ownerAgentSlots && this.editingSelectionSlots < 0);
    }
    agentSlotsError(attendant) {
        return (this.ownerAgentSlots && (this.agentSlotsNullError(attendant) || this.agentSlotsNegativeError(attendant)));
    }
    agentSlotsNullError(attendant) {
        return (this.ownerAgentSlots && (attendant.editingAgentSlots === undefined || attendant.editingAgentSlots === null || attendant.editingAgentSlots == ''));
    }
    agentSlotsNegativeError(attendant) {
        return (this.ownerAgentSlots && attendant.editingAgentSlots < 0);
    }
    get upArrow() {
        return '\uE5C7';
    }
    get downArrow() {
        return '\uE5C5';
    }
    disableSortingArrow(column) {
        if (!this.attendants) {
            return true;
        }
        switch (column) {
            case AgentsTableCategories.Name:
            case AgentsTableCategories.Email:
                return this.attendants.length === 0;
            case AgentsTableCategories.Teams:
                const teams = [];
                this.attendants
                    .map(attendant => {
                    attendant.teams?.map(team => {
                        if (!teams.includes(team)) {
                            teams.push(team);
                        }
                    });
                });
                return teams.length === 0;
            case AgentsTableCategories.Slots:
                return this.attendants.filter(attendant => attendant.agentSlots !== 0).length === 0;
            default:
                return false;
        }
    }
    updateTableSorting($event) {
        const { category, order } = $event;
        const isAscending = order === 'asc';
        this.attendants.sort((a, b) => {
            let aStringParameter;
            let bStringParameter;
            switch (category) {
                case this.categoriesEnum.Name:
                default:
                    aStringParameter = a.fullName;
                    bStringParameter = b.fullName;
                    break;
                case this.categoriesEnum.Email:
                    aStringParameter = a.email;
                    bStringParameter = b.email;
                    break;
                case this.categoriesEnum.Teams:
                    aStringParameter = a.teams.join(', ');
                    bStringParameter = b.teams.join(', ');
                    break;
                case this.categoriesEnum.Slots:
                    const aSlots = a.agentSlots !== undefined ? a.agentSlots : (this.ownerAgentSlots || -1);
                    const bSlots = b.agentSlots !== undefined ? b.agentSlots : (this.ownerAgentSlots || -1);
                    if (aSlots !== bSlots) {
                        return (isAscending ? (aSlots - bSlots) : (bSlots - aSlots));
                    }
                    break;
            }
            if (category != this.categoriesEnum.Slots && aStringParameter.toLowerCase() < bStringParameter.toLowerCase()) {
                return (isAscending ? -1 : 1);
            }
            if (category != this.categoriesEnum.Slots && aStringParameter.toLowerCase() > bStringParameter.toLowerCase()) {
                return (isAscending ? 1 : -1);
            }
            // Use fullName as tie breaker
            if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) {
                return (isAscending ? -1 : 1);
            }
            if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) {
                return (isAscending ? 1 : -1);
            }
            return 0;
        });
    }
    updateInputQueuesEdit(attendant) {
        this.editingQueues = attendant.editingTeams.map(({ label }) => label);
        this.isValidNewTeams();
    }
    cancelAddAttendant() {
        this.SegmentService.createApplicationTrack({ trackEvent: 'helpdesk-agent-add-cancel', application: this.application, payload: {} });
        this.isOpenAttendanceSection = false;
        this.newAttendants = [];
        this.newTeams = [];
        this.inputQueues = [];
        this.inputQueuesReadyValidation = false;
    }
    async clearFormAttendant() {
        this.inputQueuesReadyValidation = false;
        const form = this.formElements();
        if (!this.isBillablePlanContract) {
            await form.attendants.clear();
        }
        else {
            const attendantsChips = document.getElementById('chips-emails-contract');
            attendantsChips.chips = [];
            await this.getAttendantsInContractOptions();
            attendantsChips.options = this.attendantsOptionsData;
        }
        this.newTeams = [];
        this.newAttendants = [];
        this.inputQueues = [];
        await this.clearInputErrors();
        this.fillForm();
    }
    async convertAttendantsValueToChip(elAttendants) {
        if (!elAttendants.value) {
            return;
        }
        const attendants = elAttendants.value.split(';');
        attendants.forEach((item) => {
            elAttendants.add(item);
        });
        elAttendants.value = '';
    }
    fillForm() {
        const form = this.formElements();
        if (!this.isBillablePlanContract) {
            form.attendants.chips = this.newAttendants;
        }
        form.teams.chips = this.newTeams;
        if (this.ownerAgentSlots) {
            this.newAgentSlots = this.ownerAgentSlots;
        }
        this.checkAddAttendantButtonEnabled();
    }
    checkAddAttendantButtonEnabled() {
        if (!this.newAttendants || this.newAttendants.length <= 0) {
            this.isNewAttendantsValid = false;
        }
        this.isValidNewSlots();
    }
    async clearInputErrors() {
        const form = this.formElements();
        if (form.slots) {
            this.newAgentSlotsError = '';
            form.slots.removeAttribute('danger');
        }
        if (form.attendants) {
            this.newAttendantsError = '';
            form.attendants?.removeAttribute('danger');
        }
        if (form.teams) {
            this.newTeamsError = '';
            form.teams.removeAttribute('danger');
        }
    }
    formElements() {
        return {
            attendants: document.querySelector('bds-input-chips#chips-emails'),
            teams: document.querySelector('bds-select-chips#chips-queues'),
            slots: document.querySelector('bds-input#chips-slots'),
        };
    }
    formatAttendants(email, teams, agentSlots) {
        const attendant = {
            identity: `${encodeURIComponent(email.trim())}@${this.BLIP_DOMAIN}`,
            agentSlots: (agentSlots == this.ownerAgentSlots) ? undefined : agentSlots,
            teams,
            isEnabled: true,
        };
        return attendant;
    }
    enabledSubmitAttendants() {
        return this.isNewAgentSlotsValid && this.isNewAttendantsValid
            && (this.isFakeAtendanceProfileEnabled ? (this.newSalesAgent || this.newSupportAgent) : true);
    }
    async handleAddAttendant() {
        this.isOpenAttendanceSection = !this.isOpenAttendanceSection;
        await this.clearFormAttendant();
        this.fillForm();
    }
    async handleSubmitAttendants() {
        if (!this.enabledSubmitAttendants()) {
            return;
        }
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        let successMsg = '';
        const formattedAttendants = this.newAttendants.map(newAttendant => {
            return this.formatAttendants(newAttendant, this.newTeams, this.newAgentSlots);
        });
        if (formattedAttendants.length === 0) {
            return;
        }
        try {
            let profile = undefined;
            if (this.isFakeAtendanceProfileEnabled) {
                profile = this.newSalesAgent
                    ? AttendanceConstants.FAKE_SALES_PROFILE
                    : this.newSupportAgent
                        ? AttendanceConstants.FAKE_SUPPORT_PROFILE
                        : AttendanceConstants.FAKE_PROFILE_NOT_INFORMED;
            }
            this.trackEvent('helpdesk-agent-added', { quantityAttendants: this.newAttendants.length, quantityTeams: this.newTeams.length, profile: profile });
            await this.TeamService.set(formattedAttendants, this.loggedUser.culture);
            successMsg = await this.$translate('utils.successMsg.38');
            this.BlipToastService.show('success', { msg: successMsg });
            if (this.isFakeAtendanceProfileEnabled) {
                this.newSalesAgent = false;
                this.newSupportAgent = false;
            }
        }
        catch (error) {
            if (error == AttendanceConstants.CREATE_DIRECT_TRANSFER_TEAM_ERROR) {
                this.formElements().teams.danger = true;
                this.hasForbiddenTeam = true;
                this.isNewTeamsValid = false;
                await this.displayDirectTransferError(true);
            }
            else {
                const errorMsg = await this.$translate('utils.errorMsg.136');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
            }
        }
        await this.getTeams();
        await this.query(true);
        await this.clearFormAttendant();
        this.isOpenAttendanceSection = false;
        this.isLoading = false;
    }
    async displayDirectTransferError(hasMsg) {
        const errorMsg = await this.$translate('utils.errorMsg.175');
        const errorTitle = await this.$translate('utils.errorMsg.174');
        this.BlipToastService.show('danger', {
            msg: hasMsg ? errorMsg : '',
            title: errorTitle,
        });
    }
    async clickTrackingNewContractsAdminWarningLink() {
        this.trackEvent(TeamConstants.TRACK_ORGANIZATION_LINK_CLICK);
    }
    async attendantPermissionTrack(attendant) {
        this.trackEvent(TeamConstants.TRACK_ATTENDANT_PERMISSION_CLICK);
        this.redirectToPermission([attendant]);
    }
    async teamPermissionTrack() {
        this.trackEvent(TeamConstants.TRACK_TEAM_PERMISSION_CLICK);
        this.redirectToPermission(this.getCheckedAttendants());
    }
    trackEvent(eventName, payload = undefined) {
        this.SegmentService.createApplicationTrack({ trackEvent: eventName, application: this.application, payload: payload });
    }
    redirectToPermission(attendants) {
        const attendantsNameAndEmail = attendants.map((attendant) => ({
            identity: attendant.identity,
            fullName: attendant.fullName,
            email: attendant.email,
        }));
        const jsonAttendants = JSON.stringify(attendantsNameAndEmail);
        this.$window.sessionStorage.removeItem(TeamConstants.ATTENDANTS_TO_PERMISSION_STORED);
        this.$window.sessionStorage.setItem(TeamConstants.ATTENDANTS_TO_PERMISSION_STORED, jsonAttendants);
        this.$state.go(TeamConstants.ATTENDANT_PERMISSION_ROUTE);
    }
}
TeamController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'TeamService', '$rootScope', '$translate', 'ConfigurationsService', 'SegmentService', 'AuthenticationService', 'BlipToastService', 'BLIP_DOMAIN', 'QueuesService', 'TenantService', '$state', '$window'];
